import type { RouteObject } from "react-router-dom";
import { RouteGuard } from "@/components/RouteGuard";
import type { AppRouteDef } from "@livingsyncs/ui";

/**
 * Admin's own copy of frontend's `buildRouteTree.tsx` (frontend split epic
 * Phase 5) — translates `admin.portal.ts`'s data-authored route tree into
 * react-router `RouteObject`s, each wrapped in `<RouteGuard>`. Identical
 * logic to frontend's; only the RouteGuard import is local (see that file's
 * own note for why it isn't shared).
 */
export function buildRouteTree(routes: AppRouteDef[]): RouteObject[] {
  return routes.map((def): RouteObject => {
    const element = renderElement(def);

    if (def.index) {
      return { index: true, element };
    }

    return {
      path: def.path,
      element,
      children: def.children ? buildRouteTree(def.children) : undefined,
    };
  });
}

function renderElement(def: AppRouteDef): React.ReactNode {
  if (def.Component) {
    const Component = def.Component;
    return (
      <RouteGuard access={def.access}>
        <Component />
      </RouteGuard>
    );
  }

  if (def.element !== undefined) {
    return def.access ? (
      <RouteGuard access={def.access}>{def.element}</RouteGuard>
    ) : (
      def.element
    );
  }

  return undefined;
}
